import { call, put, takeEvery } from "redux-saga/effects";
import { types } from "../action-types";
import {
  getUserFavoritesApi,
  postFavoritesApi,
  deleteFavoritesApi,
} from "../../API/API";
import { alertNotification } from "../../components/TopNotification/alertNotification";

function* getFavoritesSaga(action) {
  try {
    const { currentPage } = action.payload;
    const { pageSize } = action.payload;
    const {type} = action.payload;
    const response = yield call(() =>
      getUserFavoritesApi(currentPage, pageSize,type)
    );
    yield put({
      type: types.GET_FAVORITES_SUCCESS,
      payload: response.data,
    });
  } catch (error) {
    yield put({ type: types.GET_FAVORITES_FAILURE, error });
  }
}

function* postFavoritesSaga(action) {
  try {
    const response = yield call(() => postFavoritesApi(action.SourceId));
    yield put({
      type: types.POST_FAVORITES_SUCCESS,
      payload: response.data,
    });
    yield put({
      type: types.GET_ONE_USER_SKILLLISTING_FAVOUTITE,
      payload: true,
    });
    alertNotification(
      "success",
      action.successMessage || "Skill listing added to favorites"
    );
    if (typeof action.onSuccess === "function") action.onSuccess();
  } catch (error) {
    yield put({ type: types.POST_FAVORITES_FAILURE, error });
    if (typeof action.onError === "function") action.onError(error);
  }
}

function* deleteFavoritesSaga(action) {
  try {
    const response = yield call(() => deleteFavoritesApi(action.SourceId));
    yield put({
      type: types.DELETE_FAVORITES_SUCCESS,
      payload: response.data,
    });

    yield put({
      type: types.GET_ONE_USER_SKILLLISTING_FAVOUTITE,
      payload: false,
    });
    alertNotification(
      "success",
      action.successMessage || "Skill listing removed from favorites"
    );
    if (typeof action.onSuccess === "function") action.onSuccess();
  } catch (error) {
    yield put({ type: types.DELETE_FAVORITES_FAILURE, error });
    if (typeof action.onError === "function") action.onError(error);
  }
}

export function* watchGetFavorites() {
  yield takeEvery(types.GET_FAVORITES_REQUESTED, getFavoritesSaga);
}

export function* watchPostFavorites() {
  yield takeEvery(types.POST_FAVORITES_REQUESTED, postFavoritesSaga);
}

export function* watchDeleteFavorites() {
  yield takeEvery(types.DELETE_FAVORITES_REQUESTED, deleteFavoritesSaga);
}
